module Sm.Core.Text

open System
open System.Text.RegularExpressions

let (|Match|_|) pattern input =
    let m = Regex.Match(input, pattern)
    if m.Success then Some(List.tail [ for g in m.Groups -> g.Value ])
    else None

let (|IsMatch|_|) pattern (input: string) =
    if Regex.IsMatch(input, pattern) then Some ()
    else None

// unfortunately an SRTP Parse recogniser which calls TryParse generates
// incorrect code in Fable, so we have to do it the hard way.

let (|Guid|_|) (value: string) =
    match Guid.TryParse value with
    | true, result -> Some result
    | _ -> None

let (|Int|_|) (value: string) =
    match Int32.TryParse value with
    | true, result -> Some result
    | _ -> None

let (|Float|_|) (value: string) =
    match Double.TryParse value with
    | true, result -> Some result
    | _ -> None

let (|Bool|_|) (value: string) =
    match value with
    | "true" -> Some true
    | "false" -> Some false
    | _ -> None

let (|DateTime|_|) (value: string) =
    match DateTime.TryParse(value) with
    | true, result -> Some result
    | _ -> None

let (|DateOnly|_|) (value: string) =
    match DateOnly.TryParse(value) with
    | true, result -> Some result
    | _ -> None

let inline join sep (parts: #seq<_>) = String.Join(sep, parts)
let inline startsWith expected (value: string) = value.StartsWith(expected, StringComparison.Ordinal)
let inline equalsIgnoreCase a b = String.Equals(a, b, StringComparison.OrdinalIgnoreCase)

let nonempty = function "" -> None | x -> Some x

let (|EmptyOrWhitespace|_|) = function
    | x when String.IsNullOrWhiteSpace(x) -> Some ()
    | _ -> None
